import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseBackgroundManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/course-backgrounds")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseBackgroundManagement />
    </RouteGuard>
  ),
});
